import React from 'react'
import { useTranslation } from 'react-i18next'
import { WifiOff } from 'lucide-react'
import { useOnlineStatus } from '../hooks/useOnlineStatus'
import { useQueueAll } from '../hooks/useQueueByTable'

export default function OfflineBanner() {
  const { t } = useTranslation()
  const { isOnline } = useOnlineStatus()
  const pending = useQueueAll()

  if (isOnline && pending.length === 0) return null

  return (
    <div
      role="status"
      aria-live="polite"
      className="mb-4 rounded-lg border border-amber-200 dark:border-amber-900 bg-amber-50 dark:bg-amber-950/30 p-3 flex items-center gap-3"
    >
      <div className="rounded-full bg-amber-100 dark:bg-amber-900/40 p-1.5 flex-shrink-0">
        <WifiOff className="w-4 h-4 text-amber-600 dark:text-amber-400" />
      </div>
      <div className="flex-1 min-w-0">
        {!isOnline && (
          <>
            <p className="text-sm font-medium text-foreground">{t('offline.banner')}</p>
            <p className="text-xs text-muted-foreground mt-0.5">{t('offline.subtitle')}</p>
          </>
        )}
        {pending.length > 0 && (
          <p className={(!isOnline ? 'mt-1 ' : '') + 'text-xs font-medium text-amber-700 dark:text-amber-400'}>
            {t('sync.pendingCount', { count: pending.length })}
          </p>
        )}
      </div>
    </div>
  )
}
